import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/login';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import styles from './style.module.scss';
import { postData, getData } from '../../services/ajax/';
import { AuthContext } from '../../context/auth';
import { LoadingModalContext } from '../../components/modal/loading';
import { AlertModalContext } from '../../components/modal/alert';
import { setYupLocaleES } from '../../const/yup';
import {
    consumeSessionEndNotice,
    clearSessionEndNotice,
    resetSessionEndGuard,
    SESSION_END_TITLES,
} from '../../services/sessionEnd';

setYupLocaleES();
const ingresarFormSchema = yup.object().shape({
    email: yup.string()
        .email("Debe ser un email válido")
        .required("El email es requerido"),
    clave: yup.string()
        .required("La contraseña es requerida")
        .min(8, "La contraseña debe tener al menos 8 caracteres"),
});

function Page() {
    const navigate = useNavigate();
    const { updateUsuario } = useContext(AuthContext);
    const loadingModal = useContext(LoadingModalContext);
    const alertModal = useContext(AlertModalContext);
    const [sessionNotice, setSessionNotice] = useState(null);

    useEffect(() => {
        const notice = consumeSessionEndNotice();
        if (notice?.code) {
            setSessionNotice(notice);
        }
    }, []);

    const onLoginSubmit = async (values, { setSubmitting }) => {
        loadingModal.setOpen(true);
        setSubmitting(true);

        try {
            const loginResponse = await postData("auth/login", {
                email: values.email,
                contrasenia: values.clave
            });

            if (loginResponse.error) {
                alertModal.showModal("Datos incorrectos", loginResponse.error);
                loadingModal.setOpen(false);
                setSubmitting(false);
                return;
            }

            const token = loginResponse.data?.token;
            if (!token) {
                alertModal.showModal("Error", "No se recibió el token de autenticación");
                loadingModal.setOpen(false);
                setSubmitting(false);
                return;
            }

            const meResponse = await getData("auth/me", token);

            if (meResponse.error) {
                alertModal.showModal("Error", meResponse.error);
                loadingModal.setOpen(false);
                setSubmitting(false);
                return;
            }

            const usuario = {
                ...meResponse.data,
                token: token
            };
            clearSessionEndNotice();
            resetSessionEndGuard();
            setSessionNotice(null);
            updateUsuario(usuario);

            navigate("/dashboard", { replace: true });
        } catch (error) {
            alertModal.showModal("Error", error.message || "Ocurrió un error al intentar iniciar sesión");
        } finally {
            loadingModal.setOpen(false);
            setSubmitting(false);
        }
    }
    return (
        <Layout>
            <Grid container direction="column">
                <h2>Ingreso</h2>
                {sessionNotice && (
                    <Alert
                        severity="warning"
                        sx={{ mb: 2, width: '100%' }}
                        onClose={() => setSessionNotice(null)}
                    >
                        <AlertTitle>
                            {SESSION_END_TITLES[sessionNotice.code] || 'Sesión finalizada'}
                        </AlertTitle>
                        {sessionNotice.message}
                    </Alert>
                )}
                <Formik
                    initialValues={{
                        email: '',
                        clave: '',
                    }}
                    validationSchema={ingresarFormSchema}
                    onSubmit={onLoginSubmit}
                >
                    {({ errors, touched, isSubmitting, values, handleChange, handleBlur }) => (
                        <Form className={styles.form}>
                            <TextField
                                variant="standard"
                                label="Email"
                                type="email"
                                autoComplete="username"
                                value={values.email}
                                onChange={handleChange('email')}
                                onBlur={handleBlur('email')}
                                error={errors.email && touched.email}
                                helperText={errors.email && touched.email ? errors.email : ""}
                                fullWidth
                            />

                            <TextField
                                variant="standard"
                                label="Contraseña"
                                type="password"
                                autoComplete="current-password"
                                value={values.clave}
                                onChange={handleChange('clave')}
                                onBlur={handleBlur('clave')}
                                error={errors.clave && touched.clave}
                                helperText={errors.clave && touched.clave ? errors.clave : ""}
                                fullWidth
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Ingresando..." : "Ingresar"}
                            </Button>
                        </Form>
                    )}
                </Formik>
            </Grid>
        </Layout>
    );
}

export default Page;
